module.exports = __webpack_public_path__ + "static/media/lazyaz_app3_preview.01e38131.jpg";